import styled from 'styled-components'

import {Input} from '../input/Input'
import {IconButton} from '../iconButton/IconButton'

export const SearchForm = styled.form<{$fillAvailable?: boolean}>`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  border: 1px solid grey;
  border-radius: ${({theme}) => theme.borderRadius.xs};
  padding-bottom: 1px;
  width: ${({$fillAvailable}) => ($fillAvailable ? '100%' : '30%')};
  min-width: ${({$fillAvailable}) => ($fillAvailable ? '21rem' : '0')};
  max-width: ${({$fillAvailable}) => ($fillAvailable ? '36rem' : 'none')};
`

export const SearchInput = styled(Input)`
  flex-grow: 2;
  border: none;
`

export const SearchButton = styled(IconButton)`
  border-radius: ${({theme}) => theme.borderRadius.xs};
  height: ${({theme}) => theme.height.input.normal};
  width: ${({theme}) => theme.height.input.normal};
`
